import React from "react";
import "./Topbar.css";
import logo from "../../assets/images/State-Distributor/logo.png";
import profile from "../../assets/images/State-Distributor/topbarProfile.png";
import { LuBellDot } from "react-icons/lu";



export const Topbar = ({ toggleSidebar }) => {
  return (
    <div
      style={{
      
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
   
      }}
      className="topbar"
    >
      {/* Hamburger Menu (Only Visible on Small Screens) */}
      {window.innerWidth < 992 && (
        <button
          onClick={toggleSidebar}
          style={{
            background: "transparent",
            border: "none",
            color: "black",
            fontSize: "24px",
            cursor: "pointer",
          }}
          className="hamburger-menu"
        >
          ☰
        </button>
      )}

     <div className="topbarLogo"><img src={logo }/></div>
     <div className="d-flex gap-3  topbarProfileContainer">
      <div  className="bellIcon"><LuBellDot /></div>
      <div className="topbarProfile"><img src={profile}/></div>

     </div>
    </div>
  );
};
